import { render, staticRenderFns } from "./ExamDrawer.vue?vue&type=template&id=28823d00&scoped=true"
import script from "./ExamDrawer.vue?vue&type=script&lang=js"
export * from "./ExamDrawer.vue?vue&type=script&lang=js"
import style0 from "./ExamDrawer.vue?vue&type=style&index=0&id=28823d00&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28823d00",
  null
  
)

export default component.exports